define("shared/utils/plans-data/new-features", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class newFeaturesUtil
   * @extends Utils
   */

  /**
   * Stores dataset on new features of plans service
   *
   * @method newFeatures
   * @param {Service} intl
   *
   * @returns {Array} New features data of plans service
   */

  const newFeatures = intl => [intl.t('plans.migrate.new_features.feature_1'), intl.t('shared_phrases.search_profile'), intl.t('plans.migrate.new_features.feature_4')];
  var _default = _exports.default = newFeatures;
});